import { createReducer, on } from '@ngrx/store';
import { Edge } from '../../../edge/edge.model';
import { UnSyncedEdgesActions } from './unsynced-edges.action-types';
import { GetUnSyncedEdgesDto } from '../../../services/sync-queue.service';

export interface UnSyncedEdgesState {
  edges: Edge.EdgeSyncQueueDocument[];
  initialLoading: boolean;
  filters: GetUnSyncedEdgesDto;
  error: any;
}

const initialState: UnSyncedEdgesState = {
  edges: [],
  initialLoading: true,
  filters: {},
  error: null,
};

export const unSyncedEdgesStateReducer = createReducer(
  initialState,
  on(UnSyncedEdgesActions.resetToInitialState, state => {
    return {
      ...initialState,
    };
  }),
  on(UnSyncedEdgesActions.getUnSyncedEdges, (state, { filters }) => {
    return {
      ...state,
      initialLoading: true,
      filters,
      error: null,
    };
  }),
  on(UnSyncedEdgesActions.getUnSyncedEdgesSuccess, (state, { edges }) => {
    return {
      ...state,
      edges,
      initialLoading: false,
      error: null,
    };
  }),
  on(UnSyncedEdgesActions.getUnSyncedEdgesFail, (state, { error }) => {
    return {
      ...state,
      initialLoading: false,
      error,
    };
  }),
  on(UnSyncedEdgesActions.setInitialLoader, (state, { loading }) => {
    return {
      ...state,
      initialLoading: loading,
    };
  }),
  on(UnSyncedEdgesActions.setFilters, (state, { filters }) => {
    return {
      ...state,
      filters,
    };
  }),
); 